import * as React from "react";
import { Link } from "react-router-dom";

import styles from "./Error404Page.module.scss";

export default function Error404Page() {
  return (
    <div>
      <main className={styles.main}>
        <p>
          お探しのページが見つかりませんでした
          <Link to={"/"}>ホーム画面に戻る</Link>
        </p>
      </main>
    </div>
  );
}
